import { Directive, ElementRef, forwardRef, HostListener, Input, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

/** needs to live alongside the old one for a while, until rest of app is converted */

@Directive({
    selector: '[casZeroPadding]'
})
export class ZeroPaddingDirective {
    @Input('casZeroPadding') public zeroPadding: number;

    @HostListener('input', ['$event'])
    public input($event) {
        let value = $event.target.value;

        if (!value) {
            value = 0;
        }

        let valStr = parseInt(value, 10).toString();
        let defaultPad = 2;
        let padLength = this.zeroPadding || defaultPad;

        while (valStr.length < padLength) {
            valStr = '0' + valStr;
        }

        $event.target.value = valStr;
    }
}
